<template>
	<div class="main-frame" :class="isIOS" :style="{ 'height': deviceHeight }">
		<div class="root" v-if="gameLoaded">
			<ContentBlock/>
		</div>

		<div class="root browser-not-allowed-message" v-else-if="browserNotAllowed">

			<div class="card card-popup">

				<h2>¡¿Asjemenou?!</h2>

				<p>Aiii, wat vervelend. Op deze telefoon kunnen we je helaas geen optimale speelervaring bieden.</p>

				<p>We raden je aan om het op je laptop of desktop computer te proberen.</p>

				<div class="visual">
					<i class="fa fa-minus"></i>
				</div>
			</div>

		</div>

		<div v-else>

			<div class="sk-circle">
				<div class="sk-circle1 sk-child"></div>
				<div class="sk-circle2 sk-child"></div>
				<div class="sk-circle3 sk-child"></div>
				<div class="sk-circle4 sk-child"></div>
				<div class="sk-circle5 sk-child"></div>
				<div class="sk-circle6 sk-child"></div>
				<div class="sk-circle7 sk-child"></div>
				<div class="sk-circle8 sk-child"></div>
				<div class="sk-circle9 sk-child"></div>
				<div class="sk-circle10 sk-child"></div>
				<div class="sk-circle11 sk-child"></div>
				<div class="sk-circle12 sk-child"></div>
			</div>

			<div class="loading"><p>{{infoText}}</p></div>
		</div>
	</div>
</template>

<script>
	import ContentBlock from './ContentBlock.vue';

	import {backend} from '../config';
	import { mapActions , mapGetters } from 'vuex'

	export default {
		props: {
			teamcode: {
				type: String,
				required: false
			},
			resp_id: {
				type: String,
				required: false
			},
			challenge_token: {
				type: String,
				required: false
			}
	    },

		components:{
			ContentBlock : ContentBlock,
		},

		data(){
			return{
				infoText: "Loading",
				browserNotAllowed: false,
				isIOS: false,
				isWindowsMobile: false,
				deviceWidth: '100%',
				deviceHeight: ''
			}
		},

		beforeMount(){
			
			if($(window).width() <= 460){
				this.deviceWidth = $(window).width()+'px';
				this.deviceHeight = $(window).height()+'px';
			}


		},

		created: function(){
			this.isIOS = this.iOS();
			//console.log('is iOS: '+this.iOS());


			this.isWindowsMobile = this.WindowsMobile();
			//console.log('is isWindowsMobile: '+this.isWindowsMobile);

			let isOldBrowser = this.isOldBrowser();

			console.log(isOldBrowser);

			if(isOldBrowser === 'isOldBrowser'){
				this.browserNotAllowed = true;
			}else{
				this.loadData();
			}




			
		},

		mounted(){

			//this.toggleFullScreen();
		},

		computed:{
			...mapGetters([
				'gameLoaded',
			]),

			
		},

		methods: {

			...mapActions([
				'loadGameData',
				'loadAudio',
				'toNextRound',
				'setTeamCode',
				'setChallengeToken'
			]),

			toggleFullScreen:function() {
			  var doc = window.document;
			  var docEl = doc.documentElement;

			  var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
			  var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

			  if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
			    requestFullScreen.call(docEl);
			  }
			  else {
			    cancelFullScreen.call(doc);
			  }
			},


			loadData:function(){
				this.loadGameData(this.teamcode).then(() => {
					
					// console.log('challengeToken: '+this.challenge_token);

					this.setChallengeToken(this.challenge_token);
					
				}).catch(error=>{
					this.infoText = "Connection error";
				});
			},

			iOS() {

				var iDevices = [
					'iPad Simulator',
					'iPhone Simulator',
					'iPod Simulator',
					'iPad',
					'iPhone',
					'iPod'
				];

				if (!!navigator.platform) {
					while (iDevices.length) {
						if (navigator.platform === iDevices.pop()){ return 'iOS'; }
					}
				}

				if(navigator.userAgent.match(/iPhone/i)){
					return 'iOS'
				}


				return false;
			},


			WindowsMobile() {
				
				if(navigator.userAgent.match(/IEMobile/i)){
					return 'isWindowsMobile'
				}
				return false;

			},

			isOldBrowser() {

				return false;
				
				const iDevices = [
					/Android 3/i,
					/iPhone OS 7_/i,
					/IEMobile/i
				];
				///iPhone OS 8_/i,

				console.log(navigator.userAgent);

				if (!!navigator.userAgent) {
					
					for (var i = 0; i < iDevices.length; i++) {

						if (navigator.userAgent.match(iDevices[i])){ return 'isOldBrowser'; }
					};
					
				}

				return false;

			},

			// var isMobile = { 
			// 	Android: function() { return navigator.userAgent.match(/Android/i); }, 
			// 	BlackBerry: function() { return navigator.userAgent.match(/BlackBerry/i); }, 
			// 	iOS: function() { return navigator.userAgent.match(/iPhone|iPad|iPod/i); }, 
			// 	Opera: function() { return navigator.userAgent.match(/Opera Mini/i); }, 
			// 	Windows: function() { return navigator.userAgent.match(/IEMobile/i); }, 
			// 	any: function() { return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows()); } };


		}

	}
</script>

<style lang="scss">
	@import "../scss/index.scss";
</style>


// WEBPACK FOOTER //
// src/components/Root.vue